import { useEffect, useRef, useState } from "react";
import { money } from "@/lib/api";

/** Animates between numeric values (ease-out, ~700ms). Renders money by default. */
export const CountUp = ({ value = 0, format = money, duration = 700, className = "", testid }) => {
  const [shown, setShown] = useState(value);
  const from = useRef(value);
  const raf = useRef(null);
  const [flash, setFlash] = useState(null); // "up" | "down"
  useEffect(() => {
    const start = from.current;
    const delta = value - start;
    if (!delta) return undefined;
    setFlash(delta > 0 ? "up" : "down");
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const e = 1 - Math.pow(1 - p, 3);
      setShown(start + delta * e);
      if (p < 1) raf.current = requestAnimationFrame(step);
      else { from.current = value; setTimeout(() => setFlash(null), 500); }
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration]);
  return (
    <span className={`inline-block tabular-nums transition-[transform,color] duration-300 ${flash === "up" ? "text-good scale-[1.06]" : flash === "down" ? "text-muted-foreground" : ""} ${className}`} data-testid={testid}>
      {format(shown)}
    </span>
  );
};
